<form>
	<div class="row g-3">
		<div class="col-9 d-flex align-items-center justify-content-center">
			<mat-form-field subscriptSizing="dynamic" appearance="outline" class="w-100">
				<mat-label>Numer konta</mat-label>
				<input
					matInput
					[formControl]="bankAccountNumberControl"
					(input)="onInput($event)"
					[maxlength]="MAX_FORMATTED_IBAN_LENGTH"
				/>
				@if (bankAccountNumberControl.hasError('iban')) {
					<mat-error
						>Wprowadź poprawny numer IBAN (z prefiksem kraju, np. PL61 1090 1014 0000 0712 1981
						2874)</mat-error
					>
				}
			</mat-form-field>
		</div>

		<div class="col-3 d-flex align-items-center justify-content-center">
			<button
				(click)="addBankAccountNumber()"
				[disabled]="!!bankAccountNumberControl.errors || bankAccountNumberControl.untouched"
				mat-raised-button
				color="primary"
				class="w-100"
			>
				Dodaj
			</button>
		</div>
	</div>
</form>

<section class="bank-account-table">
	<table class="mt-3" mat-table [dataSource]="addedBankAccounts()">
		<ng-container matColumnDef="bankAccountNumber">
			<td mat-cell *matCellDef="let element">{{ element | bankAccountFormat }}</td>
		</ng-container>

		<ng-container matColumnDef="removeBtn">
			<td mat-cell *matCellDef="let element; let i = index">
				<button (click)="removeBankAccountNumber(i)" mat-icon-button color="warn">
					<i class="fa-solid fa-xmark"></i>
				</button>
			</td>
		</ng-container>

		<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
	</table>
</section>

<mat-dialog-actions align="end">
	<button mat-raised-button mat-dialog-close="">Anuluj</button>
	<button [disabled]="!addedBankAccounts().length" mat-raised-button color="primary" (click)="closeDialogWithData()">
		Zatwierdź
	</button>
</mat-dialog-actions>
